export const getSafeRedirectPath = (value?: string | null) => {
  if (!value || !value.startsWith('/')) {
    return '/';
  }

  return value;
};

export const getAuthRedirectTarget = (search: string, fallback: string) => {
  const params = new URLSearchParams(search);
  const requestedPath = params.get('redirect') || params.get('next');

  if (!requestedPath) {
    return fallback;
  }

  const safePath = getSafeRedirectPath(requestedPath);
  return safePath === '/' && requestedPath !== '/' ? fallback : safePath;
};

export const buildAuthRedirectUrl = (pathname: string, search = '') => {
  const destination = getSafeRedirectPath(`${pathname}${search}`);
  return `/auth?redirect=${encodeURIComponent(destination)}`;
};
